module.exports = __webpack_public_path__ + "38666316607440ab08380adb761fbd90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/volume-right.png
// module id = 602
// module chunks = 0